<template lang="pug">

 .text-center
  EditVisitor( :dataVisitor="dataVisitor" :dialog="openEditVisitor" :detailVisitor="detailVisitor" @closeModal="openEditVisitor = false")
  v-dialog(v-model='dialog' scrollable persistent width='900px' style="margin-top:-30px;")
    v-card
      v-card-title.text-h5.grey.lighten-2
        | Detail Visitor
        v-btn(icon='' dark='' v-if="showEdit(detailVisitor)" @click='editVisitor()')
            v-icon(small color="green" dark ) edit
        v-btn(icon='' dark='' style=' color:black; position: absolute; right: 0' @click='onClose()')
            v-icon mdi-close
      v-card-text
        v-layout(row, wrap style="margin-top:20px;margin-bottom:-20px")
          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Nama Lengkap
          v-flex(xs7, sm7)
            v-text-field.inputDefault(
              v-model="visitorName",
              label="Nama Lengkap"
              disabled
            )
          v-flex(xs1, sm2)
         
          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Email
          v-flex(xs7, sm7)
            v-text-field.inputDefault(
              v-model="visitorEmail",
              label="Email"
              disabled
            )
          v-flex(xs1, sm2)

          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span No Handpone
          v-flex(xs7, sm7)
            v-text-field.inputDefault(
              v-model="visitorPhone",
              label="No Handpone"
              disabled
            )
          v-flex(xs1, sm2)

          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span No Darurat
          v-flex(xs7, sm7)
            v-text-field.inputDefault(
              v-model="visitorEmergency",
              label="No Darurat"
              disabled
            )
          v-flex(xs1, sm2)

          v-flex(xs4 sm3) 
            p(class="headerSection") 
              span(class="mustFill") *
              span  Golongan Darah
          v-flex(xs7 sm7)
            v-autocomplete(
              class="inputDefault"
              v-model="visitorBloodType"
              :items="golonganDarahList"
              label="Golongan Darah" disabled)
          v-flex(xs1 sm2)
          
          v-flex(xs4 sm3)
            p(class="headerSection") 
              span(class="mustFill") *
              span  Nomor KTP
          v-flex(xs7 sm7)
            v-text-field(class="inputDefault" v-model='visitorKtp' label="NIK" disabled)
          v-flex(xs1 sm2)

          v-flex(xs5 sm3) 
            p(class="headerSection") 
              span(class="mustFill") *
              span  Upload KTP
          v-flex(xs6 sm3 class="attachment" v-if="docPendukung")
            v-btn(tile text @click="download(docPendukung)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal;margin-top:17px" height="auto") 
              tr
                  td(style="padding-left:1px;" ) 
                      v-icon(small) mdi-attachment
                  td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                  td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                      img(src="../assets/check.png" width="10" )
          v-flex(xs6 sm3 class="attachmentName" v-else)
              tr
                  td(style="padding-left:1px" ) 
                      v-icon(small) mdi-attachment
                  td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                  td(style="background-color: rgb(204,204,204);padding-right:4px" )
                      img(src="../assets/close.png" width="10" class="verMiddle")
          v-flex(xs1 sm4)

          v-flex(xs12 sm12)

          v-flex(xs4 sm3)
            p(class="headerSection") 
              span(class="mustFill") *
              span  Alamat
          v-flex(xs7 sm7)
            v-text-field(class="inputDefault" v-model='visitorAddress' label="Alamat" disabled)
          v-flex(xs1 sm2)

          
          v-flex(xs4, sm3 v-if="apd !== 'Tidak' ")
            p(class="headerSection") 
              span(class="mustFill") *
              span  APD Helm
          v-flex(xs7, sm5 v-if="apd !== 'Tidak' ")
            v-radio-group(v-model="visitorApd.helm", row style="margin-top:-5px" disabled)
              v-radio(label="Ya", value="Ya")
              v-radio(label="Tidak", value="Tidak")
          v-flex(xs1, sm4 v-if="apd !== 'Tidak' ")

          v-flex(xs4, sm3 style="padding-top:10px"  v-if="apd !== 'Tidak' ")
            p(class="headerSection") 
              span(class="mustFill") *
              span  APD Rompi
          v-flex(xs7, sm5  v-if="apd !== 'Tidak' ")
            v-radio-group(v-model="visitorApd.rompi", row style="margin-top:-5px" disabled)
              v-radio(label="Ya", value="Ya")
              v-radio(label="Tidak", value="Tidak")
              v-text-field(class="inputDefault" v-model='visitorApd.ukuranRompi' label="Ukuran Rompi" disabled)
          v-flex(xs1, sm4 v-if="apd !== 'Tidak' ")

          v-flex(xs4, sm3 style="padding-top:10px" v-if="apd !== 'Tidak' ")
            p(class="headerSection") 
              span(class="mustFill") *
              span  APD Sepatu 
          v-flex(xs7, sm5 v-if="apd !== 'Tidak' ")
            v-radio-group(v-model="visitorApd.sepatu", row style="margin-top:-5px" disabled)
              v-radio(label="Ya", value="Ya")
              v-radio(label="Tidak", value="Tidak")
              v-text-field(class="inputDefault" v-model='visitorApd.ukuranSepatu' label="Ukuran Sepatu" disabled)
          v-flex(xs1, sm4 v-if="apd !== 'Tidak' ")

          v-flex(xs4 sm3 v-if="!isNotPic")
            p(class="headerSection") 
              span(class="mustFill") *
              span  Link Visitor
          v-flex(xs7 sm7 v-if="!isNotPic")
            a(:href="visitorLink" target="_blank") Link Visitor
          v-flex(xs1 sm2 v-if="!isNotPic")

          v-flex(xs4 sm3 v-if="!isNotPic")
            p(class="headerSection") 
              span(class="mustFill") *
              span  Link Induksi
          v-flex(xs7 sm1 v-if="!isNotPic")
            a(:href="visitorLinkInduction" target="_blank") Link Induksi
          v-flex(xs1 sm2 v-if="!isNotPic")

      v-divider
      v-card-actions
        v-spacer
        v-btn(v-if="!disableCancelVisitor" absolute left color='red' style="color:white;" @click='handleCancel')
          | Cancel Visitor
          v-spacer
        v-btn(color='primary' text='' @click='onClose()')  Close 
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import EditVisitor from '../components/EditVisitor.vue';
import dayJS from "dayjs"
export default {
  name: "DetailsVisitor",
  props:["dialog","detailVisitor","dataVisitor", "isAfterStartKunjungan", "isNotPic"],
  components: {
    EditVisitor
  },
  data() {
    return {
      golonganDarahList:["A","AB","B","O"],
      visitorName :'',
      openEditVisitor : false ,
      editDetailVisitor :{},
      status: null,
      visitorId :'',
      visitorPhone:'', 
      visitorEmail:'',
      visitorEmergency:'',
      visitorBloodType:'',
      visitorKtp:'',
      visitorKtpUploadId:null,
      visitorLinkInduction :'',
      apd : "",
      visitorAddress: '',
      visitorApd :{
        helm: '',
        sepatu:'',
        rompi:'',
        ukuranRompi:'',
        ukuranSepatu :''
      },
            
      docPendukung: null,

       rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),

    };
  },
  computed: {
    ...mapState(["API_URL"]),
    disableCancelVisitor() {
      return this.detailVisitor.status == 18 || this.isAfterStartKunjungan || (this.dataVisitor.ipStatus == 2 && this.dataVisitor.ipVisitorStatus == 17) || this.isNotPic;
    },
  },
  mounted() {
  },
  methods: {
    docName(name) {
      return this.$setFilename(name);
    },
    download(file) {
        if ( file.isUrl ) {
            window.open(file.url, '_blank');
        } else {
            this.$downloadFile(file);
        }
    },
    dayjs(val = undefined) {
      return dayJS(val);
    },

    showEdit(item) {
      return item.status == 7 && (this.dataVisitor.ipStatus == 2 || this.dataVisitor.ipStatus == 4) && this.dayjs().isBefore(this.dataVisitor.ipTanggalKunjungan) && !this.isNotPic
    },
    isPic() {
      return this.dataUsers.group_level.includes("PIC");
    },
    handleCancel(){
      // dataVisitor.ipNo
      const formData = {
        ipNo : this.dataVisitor.ipNo,
        visitorId : this.detailVisitor.id
      }
      const config = {
        method:  "post",
        url: `${this.API_URL}/v1/requests/cancelVisitor`,
        headers: {"Content-Type": "application/json", "Authorization": `Bearer ${this.$store.state.token}`},
        data: formData
      };
      axios(config).then(res => {
      //  console.log(res)
       if(res.statusText == "OK"){
        this.$store.dispatch("fetchDataEditRequests", res.data.data._id);
         this.$emit('closeModal', false)
       }
      }).catch(err =>{
        console.log(err.response.data)
      });

    },
    onClose(){
      this.$emit('closeModal', false)
    },
    editVisitor(){
     this.$emit('closeModal', false)
     this.openEditVisitor = true
   },
    deleteDocPendukung(name){
      let id = this.visitorKtpUploadId;  
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
  },
  watch: {
    docPendukung(params){
      if (params.isUrl) return params.url;
      if(params && params.size < 10000000){
         let formData = new FormData();
          this.visitorKtpUploadId = Date.now();
        formData.append('uploadId', this.visitorKtpUploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    detailVisitor(param){
      this.visitorName = param.name
      this.visitorPhone = param.phone
      this.visitorEmail = param.email
      this.visitorLink = param.submitDataUrl
      this.visitorLinkInduction = param.inductionUrl
      this.visitorEmergency = param.emergencyPhone
      this.visitorBloodType = param.bloodType
      this.visitorKtp = param.ktp
      this.docPendukung = param.ktpImage.docPendukung || { isUrl: true, url: param.ktpImage.docPendukungUrl }
      this.visitorAddress = param.address
      this.visitorApd.helm = param.apd.helm
      this.visitorApd.rompi = param.apd.rompi
      this.visitorApd.ukuranRompi = param.apd.ukuranRompi
      this.visitorApd.sepatu = param.apd.sepatu
      this.visitorApd.ukuranSepatu = param.apd.ukuranSepatu
    },
    dataVisitor(param){
      // console.log(param)
      this.apd = param.ipApd
    }
  }
};
</script>

<style>
/* width */

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #555; 
  border-radius: 10px;
  
}

</style>